import { useRef, useState } from "react";
import "./PhoneInput.scss";
import {
  PhoneInput as InternationalPhoneInput,
  ParsedCountry
} from "react-international-phone";
import "react-international-phone/style.css";
import { SignUpRequestValues } from "types";
import { FormikTouched } from "formik";

const PhoneInputSignUp = ({
  fullWidth,
  touched,
  errors,
  value,
  setFieldValue,
  cyId = ""
}: {
  fullWidth?: boolean;
  touched: FormikTouched<SignUpRequestValues>;
  errors: Record<string, string>;
  value: string;
  setFieldValue: any;
  cyId?: string;
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [country, setCountry] = useState<ParsedCountry>({
    areaCodes: undefined,
    dialCode: "1",
    format: "(...) ...-....",
    iso2: "us",
    name: "United States",
    priority: 0
  });

  const [isFocused, setIsFocused] = useState<boolean>(false);

  const error =
    touched && errors && touched["phone_number"] && errors["phone_number"];

  return (
    <div className="relative w-full">
      <div
        onClick={() => {
          if (inputRef?.current) {
            inputRef?.current.focus();
            inputRef?.current.setSelectionRange(-1, -1);
          }
        }}
        className="absolute top-0 cursor-text left-[58px] 
        w-[calc(100%-58px)] h-[16px] bg-transparent z-50"
        aria-hidden
      />
      <InternationalPhoneInput
        className="phone-input"
        defaultCountry="us"
        value={value}
        placeholder={(country.format as string) || "Phone number"}
        inputRef={inputRef}
        style={{
          display: "flex",
          width: "100%",
          border: error
            ? "1px solid #EF5B1B"
            : isFocused
            ? "1px solid #b8722a"
            : "1px solid rgb(204, 199, 192)",
          borderRadius: "8px",
          height: "56px"
        }}
        onChange={(phone: string, { country, inputValue }) => {
          setCountry(country);

          setFieldValue("phone_number", inputValue);
        }}
        inputStyle={{
          outline: "none",
          border: "none",
          fontSize: "1rem",
          lineHeight: "1.5",
          opacity: 1,
          display: "flex",
          flexDirection: "column",
          width: fullWidth ? "100%" : "50%",
          backgroundColor: "#FAF9F7",
          padding: "1px 12px 4px 12px",
          position: "relative",
          color: error ? "#EF5B1B" : "black",
          height: "100%",
          borderRadius: "8px"
        }}
        countrySelectorStyleProps={{
          style: {
            backgroundColor: "#FAF9F7",
            zIndex: 1000,
            color: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px 0 0 8px"
          },
          buttonStyle: {
            width: "100%",
            height: "100%"
          },
          dropdownStyleProps: {
            style: {
              backgroundColor: "rgba(255,255,255, 1)",
              color: "black",
              zIndex: 1000
            }
          }
        }}
        inputProps={{
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
          // @ts-ignore
          "data-cy": cyId
        }}
      />
      <span
        className={`${
          error ? "opacity-1" : "opacity-0"
        } text-xs text-error font-['Inter'] ml-4 mt-[4px] mb-[12px] min-h-[16px] !leading-4`}
        data-cy={`${cyId}-error`}
        style={{
          color: "#EF5B1B",
          fontSize: "0.75rem",
          marginTop: "0.25rem"
        }}
      >
        {error ? errors["phone_number"] : ""}
      </span>
    </div>
  );
};

export default PhoneInputSignUp;
